import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useRouter } from '@tanstack/react-router';
import { useState } from 'react';
import type { AdminApi } from '../../api/client.ts';
import { HistoryDrawer } from './HistoryDrawer.tsx';

interface Props {
  environmentId: string;
  objectType: string;
  objectId: string;
  label: string;
}

/** "N changes since last viewed" for one object; opening the history marks it as viewed (BB-16). */
export function ChangesBadge({ environmentId, objectType, objectId, label }: Props) {
  const { api } = useRouter().options.context as { api: AdminApi };
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const queryKey = ['changes', environmentId, objectType, objectId];
  const changes = useQuery({ queryKey, queryFn: () => api.objectChanges(environmentId, objectType, objectId) });
  const viewed = useMutation({
    mutationFn: () => api.markViewed(environmentId, objectType, objectId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });
  if (!changes.data) return null;
  const count = changes.data.changesSinceLastViewed;

  return (
    <>
      <button
        type="button"
        className={count > 0 ? 'changes-badge changes-badge--new' : 'changes-badge'}
        onClick={() => {
          setOpen(true);
          viewed.mutate();
        }}
      >
        {count} {count === 1 ? 'change' : 'changes'} since last viewed
      </button>
      <HistoryDrawer title={`History: ${label}`} events={changes.data.events} open={open} onClose={() => setOpen(false)} />
    </>
  );
}
